
import Scroller from 'vux/src/components/scroller/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Picker from 'vux/src/components/picker/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {eventBus} from '../../../eventbus'
export default {
components: { Scroller, Checker, CheckerItem, Picker, GroupTitle, XButton, PopupRadio, XDialog, Flexbox, FlexboxItem },
data () {
return {
caseId: this.$route.params.caseid,
reportId: this.$route.params.reportid,
diagCropMin: '',
diagCropMax: '',
cropList: [],
cropAddrArray: [],
diagnoseDescShow: '',
diagnoseDescTitle: '',
microbeProjectShow: '',
microbeProjectTitle: '',
diagnoseResultShow: '',
diagnoseResultTitle: '',
dnaResultShow: '',
dnaResultTitle: '',
returnCellResult: '',
groupCellResult: '',
cellResultShow: '',
cellResultTitle: '',
remarkShow: '',
remarkTitle: '',
oneKnowledge: [],
twoKnowledge: [],
threeKnowledge: [],
fourKnowledge: [],
oneValue: [''],
twoValue: [''],
threeValue: [''],
fourValue: [''],
oneShow: true,
twoShow: true,
threeShow: true,
fourShow: true,
iconfont: ['iconfont', 'cell-adopt-report-icon-padding'],
iconDown: 'icon-circle-down',
iconUp: ['icon-circle-up', 'cell-adopt-report-blue'],
innerCtn: 'cell-adopt-report-innerCtn',
innerCtnBig: 'cell-adopt-report-innerCtn-big',
groupDiagnoseDesc: '',
groupMicrobeProject: '',
groupDiagnoseResult: '',
groupRemark: '',
returnDiagnoseDesc: '',
returnMicrobeProject: '',
returnDiagnoseResult: '',
returnRemark: '',
tipShow: false,
tip: '',
returnCellResult1: '',
returnCellResult2: '',
returnCellResult3: '',
returnCellResult4: '',
returnCellResult5: '',
groupCellResult1: '',
groupCellResult2: '',
groupCellResult3: '',
groupCellResult4: '',
groupCellResult5: '',
clickCount: 0,
fullClickShow: false,
partClickShow: false
}
},
computed: {
subjectResultText: function () {
return this.returnDiagnoseDesc + '\r\n' + this.returnMicrobeProject
}
},
beforeMount () {
this.$vue = this
this.getPageData()
},
methods: {
async getPageData () {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('ID', this.reportId)
let succ = await this.$http.post(this.$vue.getData('ADOPT_REPORT'), params)
if (succ.data.result === '1') {
this.diagCropMin = succ.data.data.pdModelConfig.DIAGNOSE_CROP_MIN
this.diagCropMax = succ.data.data.pdModelConfig.DIAGNOSE_CROP_MAX
this.diagnoseDescShow = succ.data.data.pdModelConfig.DIAGNOSE_DESC_SHOW === '1'
this.diagnoseDescTitle = succ.data.data.pdModelConfig.DIAGNOSE_DESC_TITLE
this.microbeProjectShow = succ.data.data.pdModelConfig.MICROBE_DESC_SHOW === '1'
this.microbeProjectTitle = succ.data.data.pdModelConfig.MICROBE_DESC_TITLE
this.diagnoseResultShow = succ.data.data.pdModelConfig.DIAGNOSE_RESULT_SHOW === '1'
this.diagnoseResultTitle = succ.data.data.pdModelConfig.DIAGNOSE_RESULT_TITLE
this.dnaResultShow = succ.data.data.pdModelConfig.DNA_RESULT_SHOW === '1'
this.dnaResultTitle = succ.data.data.pdModelConfig.DNA_RESULT_TITLE
this.cellResultShow = succ.data.data.pdModelConfig.CELL_RESULT_SHOW === '1'
this.cellResultTitle = succ.data.data.pdModelConfig.CELL_RESULT_TITLE
this.remarkShow = succ.data.data.pdModelConfig.REMARK_SHOW === '1'
this.remarkTitle = succ.data.data.pdModelConfig.REMARK_TITLE
this.cropList = succ.data.data.cropList
this.cropAddrArray = succ.data.data.cropAddrArray
this.groupCellResult = succ.data.data.groupReport.DNA_RESULT
this.groupCellResult1 = this.groupCellResult.substring(this.groupCellResult.indexOf(':') + 2, this.groupCellResult.indexOf('细胞：') + 3)
this.groupCellResult2 = this.groupCellResult.substring(this.groupCellResult.indexOf('细胞：') + 3, this.groupCellResult.indexOf('个，'))
this.groupCellResult3 = this.groupCellResult.substring(this.groupCellResult.indexOf('个，'), this.groupCellResult.lastIndexOf('细胞：') + 3)
this.groupCellResult4 = this.groupCellResult.substring(this.groupCellResult.lastIndexOf('细胞：') + 3, this.groupCellResult.lastIndexOf('个。'))
this.groupCellResult5 = this.groupCellResult.substring(this.groupCellResult.lastIndexOf('个。'), this.groupCellResult.length)
this.returnCellResult = succ.data.data.returnReport.DNA_RESULT
this.returnCellResult1 = this.returnCellResult.substring(this.returnCellResult.indexOf(':') + 2, this.returnCellResult.indexOf('细胞：') + 3)
this.returnCellResult2 = this.returnCellResult.substring(this.returnCellResult.indexOf('细胞：') + 3, this.returnCellResult.indexOf('个，'))
this.returnCellResult3 = this.returnCellResult.substring(this.returnCellResult.indexOf('个，'), this.returnCellResult.lastIndexOf('细胞：') + 3)
this.returnCellResult4 = this.returnCellResult.substring(this.returnCellResult.lastIndexOf('细胞：') + 3, this.returnCellResult.lastIndexOf('个。'))
this.returnCellResult5 = this.returnCellResult.substring(this.returnCellResult.lastIndexOf('个。'), this.returnCellResult.length)
this.groupDiagnoseDesc = succ.data.data.groupReport.groupDiagDesc
this.returnDiagnoseDesc = succ.data.data.returnReport.returnDiagDesc
this.oneValue = succ.data.data.returnReport.returnDiagDesc.length === 0 ? [''] : succ.data.data.returnReport.returnDiagDesc
this.groupMicrobeProject = succ.data.data.groupReport.groupMicroPro
this.returnMicrobeProject = succ.data.data.returnReport.returnMicroPro
this.fourValue = succ.data.data.returnReport.returnMicroPro.length === 0 ? [''] : succ.data.data.returnReport.returnMicroPro
this.groupDiagnoseResult = succ.data.data.groupReport.groupDiagnoseResult
this.returnDiagnoseResult = succ.data.data.returnReport.returnDiagnoseResult
this.twoValue = succ.data.data.returnReport.returnDiagnoseResult.length === 0 ? [''] : succ.data.data.returnReport.returnDiagnoseResult
this.groupRemark = succ.data.data.groupReport.groupRecommendation
this.returnRemark = succ.data.data.returnReport.returnRecommendation
this.threeValue = succ.data.data.returnReport.returnRecommendation.length === 0 ? [''] : succ.data.data.returnReport.returnRecommendation
this.oneKnowledge = succ.data.data.oneKnowledge
this.twoKnowledge = succ.data.data.twoKnowledge
this.threeKnowledge = succ.data.data.threeKnowledge
this.fourKnowledge = succ.data.data.fourKnowledge
}
},
oneChange () {




this.returnDiagnoseDesc = this.oneValue.toString().replace(/,/g, '\r\n')

},
twoChange () {
this.returnDiagnoseResult = this.twoValue.toString().replace(/,/g, '')
},
threeChange () {
this.returnRemark = this.threeValue.toString().replace(/,/g, '')
},
fourChange () {




this.returnMicrobeProject = this.fourValue.toString().replace(/,/g, '\r\n')

},
fullAdopt () {
if (this.clickCount === 0) {
this.fullClickShow = true
this.returnDiagnoseDesc = this.groupDiagnoseDesc
this.oneValue = this.returnDiagnoseDesc.split('\r\n')
this.returnMicrobeProject = this.groupMicrobeProject
this.fourValue = this.returnMicrobeProject.split('\r\n')
this.returnDiagnoseResult = JSON.parse(JSON.stringify(this.groupDiagnoseResult))
this.twoValue = this.returnDiagnoseResult
this.returnRemark = JSON.parse(JSON.stringify(this.groupRemark))
this.threeValue = this.returnRemark
this.clickCount++
}
},
partAdopt () {
if (this.clickCount === 0) {
this.partClickShow = true
this.returnDiagnoseResult = (this.returnDiagnoseResult + ',' + this.groupDiagnoseResult).split(',')
this.twoValue = this.returnDiagnoseResult
this.returnRemark = (this.returnRemark + ',' + this.groupRemark).split(',')
this.threeValue = this.returnRemark
this.clickCount++
}
},
async finishDiagnose (method) {
let subjectResultText = this.subjectResultText
if (subjectResultText === '') {
this.tip = '请添加诊断描述和微生物项目词条！'
this.tipShow = true
return false
}
let diagnoseDesc = this.returnDiagnoseDesc
if (diagnoseDesc === '') {
this.tip = '请添加诊断描述词条！'
this.tipShow = true
return false
}
if (this.microbeProjectShow) {
let microbeProject = this.returnMicrobeProject
if (microbeProject === '') {
this.tip = '请添加微生物项目词条！'
this.tipShow = true
return false
}
}
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('cropAddrArray', this.cropAddrArray)
params.append('diagnoseDesc', this.returnDiagnoseDesc)
params.append('microbeProject', this.returnMicrobeProject)
params.append('diagnoseResult', this.returnDiagnoseResult)
params.append('remark', this.returnRemark)
let cellRes = this.returnCellResult
let re = /^[0-9]+$/
if (re.test(this.returnCellResult4)) {
let str = this.returnCellResult.substring(this.returnCellResult.lastIndexOf('细胞：') + 3, this.returnCellResult.lastIndexOf('个。'))
if (Number(this.returnCellResult4) > Number(str)) {
this.tip = '异常细胞数只能变小！'
this.tipShow = true
return false
} else {
let param = new URLSearchParams()
param.append('CASE_ID', this.caseId)
param.append('INITIAL_LESION_NUM', Number(str))
param.append('MODIFY_LESION_NUM', Number(this.returnCellResult4))
await this.$http.post(this.$vue.getData('DELETE_CROP_URL'), param)
cellRes = this.returnCellResult.substring(0, this.returnCellResult.lastIndexOf('细胞：') + 3) + this.returnCellResult4 + this.returnCellResult.substring(this.returnCellResult.lastIndexOf('个。'), this.returnCellResult.length)
}
} else {
this.tip = '异常细胞数请输入非负整数！'
this.tipShow = true
return false
}
params.append('cellResult', cellRes)
params.append('subjectResultText', this.subjectResultText)
params.append('method', method)
params.append('TO_ADOPT', 1)
params.append('GROUP_REPORT_ID', this.reportId)

eventBus.$emit('showLoading', true, '加载中')
let suc = await this.$http.post(this.$vue.getData('FINISH_DIAGNOSE'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data, finishDiagnose: true} })
}

eventBus.$emit('showLoading', false)
},
back () {

}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/report/cellAdoptReport.vue